import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { profileKeys } from '@core/react-query/features/profile'
import { ICheckInSession } from '@core/entities/checkIn'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getExtendPermitCheckInMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useExtendPermitCheckIn>[0] = {},
): Parameters<typeof useExtendPermitCheckIn>[0] => ({
  ...options,
  ...permitKeys.extendCheckIn,
  onSuccess: (_, variables, context) => {
    queryClient.invalidateQueries(
      permitKeys.byId({ permitId: variables.permitId }).queryKey,
    )
    queryClient.invalidateQueries(dashboardKeys.getDashboardPermitStats._def)
    queryClient.invalidateQueries(profileKeys.getUserStats._def)
    options.onSuccess?.(_, variables, context)
  },
})

export const useExtendPermitCheckIn = (
  options: UseMutationOptions<
    ICheckInSession[],
    RequestErrorType,
    RequestTypes['extendCheckIn']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(
    getExtendPermitCheckInMutationOptions(queryClient, options),
  )
}
